// Inline SVG "billboard" wordmark — bold sans-serif approximation of the
// Billboard magazine masthead. Rendered white for the dark theme.
export default function BillboardLogo({ className = "", height = 14 }) {
  return (
    <svg
      viewBox="0 0 220 44"
      role="img"
      aria-label="Billboard"
      className={className}
      style={{ height, width: "auto" }}
      preserveAspectRatio="xMidYMid meet"
    >
      <text
        x="0"
        y="36"
        fontFamily="'Outfit', 'Helvetica Neue', sans-serif"
        fontWeight="900"
        fontSize="44"
        letterSpacing="-0.03em"
        fill="currentColor"
      >
        billboard
      </text>
    </svg>
  );
}
